jQuery(document).ready(function () {
  // Readonly vs Disable field differences described here: http://stackoverflow.com/a/7730719/634386
  // Readonly Fields
  jQuery('.gf_readonly textarea, .gf_readonly input').attr('readonly', 'readonly');
  jQuery('.gf_readonly select option').each(function () {
    if (this.selected && (this.text !== '--' || this.text !== '')) {
      jQuery(this).parent().attr('readonly', 'readonly').trigger('chosen:updated');
    }
  });
  // Disabled Fields
  jQuery('.gf_disabled textarea, .gf_disabled input').attr('disabled','disabled');
  jQuery('.gf_disabled select option').each(function() {
    if (this.selected && this.text !== '--' && this.text !== '') {
      jQuery(this).parent().attr('disabled','disabled');
    }
  });
});
